<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch3">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch3.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-3">Dangerous experiment? What does that mean? you wonder. You notice that the door is slightly open. Oh, no! Denny must have run in here, you think.</a></p><a id="pg-3">
<p class="para" style="text-indent: 5%;">You push the door open wider and peek in. There’s no sign of Denny. A tall, skinny man with long white hair tied in a ponytail is bent over a computer. The computer is hooked up to a big, strange-looking clock. Between the computer and the clock is a large square contraption that looks like a picture frame. You can hear the computer and the clock beeping and pinging.</p>
<p class="para" style="text-indent: 5%;">“It’s about time you got here!” the tall man says, straightening up. “I’m Dr. Peebles. You must be the volunteer.”</p>
<p class="para" style="text-indent: 5%;">“Actually,” you start to say, “I’m looking for —”</p>
<p class="para" style="text-indent: 5%;">“There’s no time to waste!” Dr. Peebles interrupts. “I’m ready to start the experiment. Come on over.”</p>
<p class="para" style="text-indent: 5%;">“Well, I —”</p>
<p class="para" style="text-indent: 5%;">“Here!” he says. He places a chain around your neck. On the end of the chain is something that looks like a stopwatch. A very, very odd stopwatch, with a complicated-looking dial and four big knobs.</p>
<p class="para" style="text-indent: 5%;">“Are you ready?” Dr. Peebles asks.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-3"><em class="italic">Turn to </em></a><a href="#/e9780545841016_ch004"><em class="italic">PAGE 4</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841016_ch003.vue?45bbee51